import React from 'react';
import './price-block.scss'
import {useTranslation} from "react-i18next";

function PriceBlock() {
    const { t } = useTranslation()

    return (
        <div id="price" className="price-block container mt mb">

            <div className="price-block__text-wrapper" data-aos="fade-down">
                <h4 className="price-block__title title">{t('price_block.title_start')} {t('price_block.title_end')}</h4>
                <span className="price-block__description">{t('price_block.description')}</span>
                <div className="line">
                    <div className="circle"></div>
                </div>
            </div>

            <div className="price-block__wrapper">

                <div className="price-block__item" data-aos="zoom-in">

                    <div className="price-block__item-top">
                        <div className="price-block__item-inner-wrapper">
                            <h5 className="price-block__item-title">{t('price_block.item_plan')}</h5>
                            <span className="price-block__item-subtitle">{t('price_block.item_price')}</span>
                        </div>

                        {/*<h6 className="price-block__deposite">{t('price_block.item_deposit2')}</h6>*/}
                    </div>

                    <p>{t('price_block.item_text')}</p>


                    <div className="price-block__item-bottom">
                        <button
                            className="price-block__button button button--white">{t('price_block.item_button')}</button>
                        <span>{t('price_block.item_link')}</span>
                    </div>

                </div>

                <div className="price-block__item" data-aos="zoom-in">

                    <div className="price-block__item-top">
                        <div className="price-block__item-inner-wrapper">
                            <h5 className="price-block__item-title">{t('price_block.item_plan2')}</h5>
                            <span className="price-block__item-subtitle">{t('price_block.item_price')}</span>
                        </div>

                        {/*<h6 className="price-block__deposite">{t('price_block.item_deposit2')}</h6>*/}
                    </div>

                    <p>{t('price_block.item_text2')}</p>


                    <div className="price-block__item-bottom">
                        <button
                            className="price-block__button button button--white">{t('price_block.item_button')}</button>
                        <span>{t('price_block.item_link')}</span>
                    </div>

                </div>

                <div className="price-block__item" data-aos="zoom-in">

                    <div className="price-block__item-top">
                        <div className="price-block__item-inner-wrapper">
                            <h5 className="price-block__item-title">{t('price_block.item_plan3')}</h5>
                            <span className="price-block__item-subtitle">{t('price_block.item_price')}</span>
                        </div>

                        {/*<h6 className="price-block__deposite">{t('price_block.item_deposit2')}</h6>*/}
                    </div>

                    <p>{t('price_block.item_text3')}</p>


                    <div className="price-block__item-bottom">
                        <button
                            className="price-block__button button button--white">{t('price_block.item_button')}</button>
                        <span>{t('price_block.item_link')}</span>
                    </div>

                </div>

            </div>


        </div>
    );
}

export default PriceBlock;